export class ListNode {
  public expandable: boolean = false;

  constructor(public item: any, public level: number = 1, public isLoading: boolean = false) {
    this.expandable = item.get('type') === 'Folder';
  }
}
